import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import CreateRawGenericMappingCommand from "../GenericMappings/Models/Commands/CreateRawGenericMappingCommand";
import UpdateRawGenericMappingCommand from "../GenericMappings/Models/Commands/UpdateRawGenericMappingCommand";
import DestinationFieldLookup from "../GenericMappings/Models/Lookups/DestinationFieldLookup";
import DestinationTableLookup from "../GenericMappings/Models/Lookups/DestinationTableLookup";
import RawGenericMappingLookup from "../GenericMappings/Models/Lookups/RawGenericMappingLookup";
import SourceFieldStaticOptionLookup from "../GenericMappings/Models/Lookups/SourceFieldStaticOptionLookup";
import RawGenericMappingSearchCriteria from "../GenericMappings/Models/Queries/RawGenericMappingSearchCriteria";

export interface IRawGenericMappingApiClient {
    addNewRawGenericMapping(command: Model.PlainObject<CreateRawGenericMappingCommand>) : AxiosPromise<Model.PlainObject<CommandResult>>;
    getDestinationFieldListByCriteria(criteria: string, destinationTableID: number) : AxiosPromise<Array<Model.PlainObject<DestinationFieldLookup>>>;
    getDestinationTablesList() : AxiosPromise<Array<Model.PlainObject<DestinationTableLookup>>>;
    getRawGenericMappingsPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<RawGenericMappingSearchCriteria>>) : AxiosPromise<Data.PageResult<Model.PlainObject<RawGenericMappingLookup>>>;
    getSourceFieldsList() : AxiosPromise<Array<Model.PlainObject<SourceFieldStaticOptionLookup>>>;
    updateRawGenericMapping(command: Model.PlainObject<UpdateRawGenericMappingCommand>) : AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class RawGenericMappingApiClient extends Data.ApiClientBase implements IRawGenericMappingApiClient {
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/RawGenericMapping`)
    }

    public addNewRawGenericMapping(command: Model.PlainObject<CreateRawGenericMappingCommand>) : AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewRawGenericMapping`, command);
    }

    public getDestinationFieldListByCriteria(criteria: string, destinationTableID: number) : AxiosPromise<Array<Model.PlainObject<DestinationFieldLookup>>> {
        return this.axios.get(`${this.apiPath}/GetDestinationFieldListByCriteria`, { params: { destinationTableID: destinationTableID, criteria: criteria } });
    }

    public getDestinationTablesList() : AxiosPromise<Array<Model.PlainObject<DestinationTableLookup>>> {
        return this.axios.get(`${this.apiPath}/GetDestinationTablesList`);
    }

    public getRawGenericMappingsPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<RawGenericMappingSearchCriteria>>) : AxiosPromise<Data.PageResult<Model.PlainObject<RawGenericMappingLookup>>> {
        return this.axios.get(`${this.apiPath}/GetRawGenericMappingsPagedList?${Utils.getQueryString(payload)}`);
    }

    public getSourceFieldsList() : AxiosPromise<Array<Model.PlainObject<SourceFieldStaticOptionLookup>>> {
        return this.axios.get(`${this.apiPath}/GetSourceFieldStaticOptionsList`);
    }

    public updateRawGenericMapping(command: Model.PlainObject<UpdateRawGenericMappingCommand>) : AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/UpdateRawGenericMapping`, command);
    }
}